var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIconWithoutBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.09 14.47h0l.005-.004a.58.58 0 00.155-.423.56.56 0 00-.155-.396l-3.336-3.335a.533.533 0 00-.269-.143c.303-.42.544-.886.736-1.396.256-.655.399-1.342.399-2.085 0-1.087-.287-2.058-.798-2.967h0l-.003-.005A6.07 6.07 0 009.66 1.551h0l-.005-.003C8.745 1.037 7.774.75 6.688.75a6.03 6.03 0 00-2.994.798h0l-.005.003a5.79 5.79 0 00-2.14 2.168C1.007 4.633.75 5.607.75 6.688c0 1.08.256 2.08.8 2.996a5.53 5.53 0 002.141 2.142c.916.543 1.917.799 2.997.799.711 0 1.397-.114 2.083-.371h0l.004-.002a6.24 6.24 0 001.393-.768c.02.098.065.196.144.275h0l3.32 3.293c.04.055.094.11.17.148a.53.53 0 00.241.05.583.583 0 00.42-.18l.628-.6zm-4.845-5.721h0l-.002.004A4.029 4.029 0 018.75 10.27a4.183 4.183 0 01-2.063.541 4.035 4.035 0 01-2.062-.54h0l-.004-.002a3.91 3.91 0 01-1.517-1.517h0l-.002-.004a4.036 4.036 0 01-.54-2.062c0-.721.18-1.417.54-2.063a4.03 4.03 0 011.52-1.492h0l.003-.002a4.058 4.058 0 012.061-.567c.717 0 1.413.204 2.064.568.617.36 1.132.876 1.493 1.493.364.651.569 1.347.569 2.064 0 .745-.206 1.44-.568 2.061z",
    fill: "url(#searchIconWithoutBorder_svg__paint0_linear)",
    stroke: "url(#searchIconWithoutBorder_svg__paint1_linear)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "searchIconWithoutBorder_svg__paint0_linear",
    x1: 8.824,
    y1: 27.293,
    x2: 20.153,
    y2: 22.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#218FEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "searchIconWithoutBorder_svg__paint1_linear",
    x1: 8.824,
    y1: 27.293,
    x2: 20.153,
    y2: 22.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#218FEE"
  })))));
}

export default SvgSearchIconWithoutBorder;